import React, { useEffect, useState } from "react";

export default function CertificazioneManagerForm({
  formCertificazioneManager,
  setFormCertificazioneManager,
  showModalCertificazioneManager,
}) {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormCertificazioneManager(prevState => ({ ...prevState, [name]: value }));
  };

  useEffect(() => {
    if (!showModalCertificazioneManager) {
      setFormCertificazioneManager({});
    }
  }, [showModalCertificazioneManager]);

  return (
    <div className="container">
      <div className='row'>
        <div className='col-sm-12 my-2'>
          <span className='small text-muted d-block mb-1'><b>Descrizione</b></span>
          <textarea 
            name="descrizione" 
            value={formCertificazioneManager.descrizione || ''} 
            onChange={handleInputChange} 
            className="form-control" 
            type="text" 
            placeholder="Descrizione"
            rows={3}
          />
        </div>
      </div>
    </div>
  );
}
